<template>
  <button
    class="btn bg-secondary border-0 bg-opacity-05 d-flex align-items-center justify-content-center gap-2 py-2 px-4"
    @click="authorizedContinue()"
  >
    {{ $t(`app.${isAutorized ? "onLogout" : "onLogin"}`) }}
    <i class="bi bi-box-arrow-in-right" v-if="!isAutorized"></i>
    <i class="bi bi-box-arrow-right" v-else></i>
  </button>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { AccessToken } from "@/api/accessDecoder";

@Options({
  components: {},
})
class LoginButton extends Vue {
  get isAutorized(): boolean {
    return AccessToken.isAuthorized;
  }

  authorizedContinue(): void {
    AccessToken.logout();
  }
}
export default LoginButton;
</script>
<style lang="scss" scoped></style>
